"use client"
//@ts-nocheck
import { create } from "zustand";

type SidebarStore = {
    isCollapsed: boolean;
    isUserCollapsed: boolean;
    toggleCollapsed: () => void;
    toggleUserSidebarCollapsed: () => void;
}

// Проверяем доступность localStorage
const isLocalStorageAvailable = typeof localStorage !== "undefined";

let initValue = false;
let userSidebarInitValue = false;

if (isLocalStorageAvailable) {
    const localValue = localStorage.getItem("isSidebarCollapsed");
    initValue = localValue === "true";

    const localUserValue = localStorage.getItem("isUserCollapsed");
    userSidebarInitValue = localUserValue === "true";
}

export const useSidebarStore = create<SidebarStore>((set) => ({
    isCollapsed: initValue,
    isUserCollapsed: userSidebarInitValue,
    toggleCollapsed: () => {
        set((state) => {
            const newCollapsedState = !state.isCollapsed;
            if (isLocalStorageAvailable) {
                localStorage.setItem("isSidebarCollapsed", newCollapsedState.toString());
            }
            return { isCollapsed: newCollapsedState };
        });
    },
    toggleUserSidebarCollapsed: () => {
        set((state) => {
            const newCollapsedState = !state.isUserCollapsed;
            if (isLocalStorageAvailable) {
                localStorage.setItem("isUserCollapsed", newCollapsedState.toString());
            }
            return { isUserCollapsed: newCollapsedState };
        })
    }
}));